export const ACCOUNTS = 'ACCOUNTS';
export const ACCOUNTS_BUSY = 'ACCOUNTS_BUSY';
export const ACCOUNTS_CREATE_BUSY = 'ACCOUNTS_CREATE_BUSY';
export const ACCOUNTS_AUTH_BUSY = 'ACCOUNTS_AUTH_BUSY';
export const SELECTED_ACCOUNT = 'SELECTED_ACCOUNT';
export const SELECTED_ACCOUNT_DATA = 'SELECTED_ACCOUNT_DATA';
